import OpenCloseCell from './OpenCloseCell.vue';
import RangeContainer from './RangeContainer.vue'
import RangeControl from './RangeControl.vue'
import ChartControl from './ChartControl.vue'
import PriceContent from './PriceContent.vue';
import { formatPrice } from '@/utils';
import TenDaysRow from './TenDaysRow';
import MktValue from './MktValue';
import WaitIndicator from '@/components/Common/WaitIndicator.vue';
import { extractJsonDate, formatDate, formatNewDate } from '@/utils/formatters';

import vue from 'vue'

export default vue.extend({
    name: 'PortfolioOptionRow',
    props: {
        index: { type: Number, required: true },
        symbol: { type: Object, required: true }
    },
    computed: {
        StartDateStr() {
            return formatDate(extractJsonDate(this.symbol.startDate)).split(',')[0];
        },
        est() {
            return this.symbol.estValue == 0 ? '-' : formatPrice(this.symbol.estValue);
        },
        errorRow() {
            return this.symbol.dailyError && this.symbol.monthError;
        },
        corridorHigh() {
            return 0.25 * this.symbol.predictionError * this.symbol.predictionHigh;
        },
        corridorLow() {
            return 0.25 * this.symbol.predictionError * this.symbol.predictionLow;
        },
        PredictionLow() {
            return this.symbol.predictionLow == 0 ? '-' : formatPrice(this.symbol.predictionLow);
        },
        PredictionHigh() {
            return this.symbol.predictionHigh == 0 ? '-' : formatPrice(this.symbol.predictionHigh);
        },
        OptionDescription() {
            return 'Bid: ' + formatPrice(this.symbol.bidPrice) + ', Ask: ' + formatPrice(this.symbol.askPrice) + ', Last: ' + formatPrice(this.symbol.lastPrice);
        },
    },
    components: {
        RangeContainer,
        WaitIndicator,
        TenDaysRow,
        PriceContent,
        OpenCloseCell,
        MktValue,
        RangeControl,
        ChartControl
    },
});